import type { ReactNode } from "react";
import "./DisplayOptionsMenu.scss";
import TimeUnits from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/time-units/TimeUnits.tsx";
import DisplayToggles from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/display-toggles/DisplayToggles.tsx";
import DailyTagsSelector from "@/pages/human-resources/time-management/schedules/site-schedule/toolbar/display-options/menu/daily-tags-selector/DailyTagsSelector.tsx";
import ValorizedOrEffectiveDuration from "./valorized-or-effective-duration/ValorizedOrEffectiveDuration.tsx";
import useScheduleRangeOnRoute from "@/pages/human-resources/time-management/hooks/useScheduleRangeOnRoute.ts";

export default function DisplayOptionsMenu(): ReactNode {
  const range = useScheduleRangeOnRoute();
  return (
    <div className="display-options-menu">
      {range === "MONTH" && <ValorizedOrEffectiveDuration />}
      <TimeUnits />
      <DisplayToggles />
      <DailyTagsSelector />
    </div>
  );
}
